import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import useAuth from "@/hooks/useAuth";

import Header from "./components/Header";
import Menu from "./components/Menu";
import Content from "./components/Content";

const Default = ({ children, form, isPublic }) => {
  const {
    name,
    workspaces,
    currentWorkspace,
    isLoggedIn,
    handleLogout,
    isSubscriptionValid,
    resetPasswordToken,
  } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleRouteChange = useCallback(() => {
    if (!isLoggedIn && !location.pathname.includes("/login") && !isPublic) {
      const isAutomaticLoggout = true;
      handleLogout(isAutomaticLoggout);
      navigate("/login");
    }
  }, [isLoggedIn, handleLogout, navigate, location, isPublic]);

  useEffect(() => {
    if (!isPublic && !isLoggedIn) {
      const isAutomaticLoggout = true;
      handleLogout(isAutomaticLoggout);
    }
  }, [isPublic, isLoggedIn, handleLogout]);

  const handleSetAccess = useCallback(() => {
    if (!isPublic && !!resetPasswordToken) {
      return navigate(`/primeiro-acesso/${resetPasswordToken}`);
    }

    if (!isPublic && !isSubscriptionValid) {
      return navigate("/verificacao");
    }
  }, [resetPasswordToken, isPublic, isSubscriptionValid, navigate]);

  useEffect(() => {
    handleSetAccess();
  }, [handleSetAccess]);

  useEffect(() => {
    handleRouteChange();
  }, []);

  if (!isLoggedIn && !location.pathname.includes("/login") && !isPublic) {
    return <></>;
  }

  if (!isSubscriptionValid) {
    return <>Você não possui uma assinatura ativa</>;
  }

  return (
    <div>
      <Menu />

      <div className="flex flex-col">
        <Header
          name={name}
          workspace={workspaces}
          currentWorkspace={currentWorkspace}
        />

        <Content form={form}>{children}</Content>
      </div>
    </div>
  );
};

export default Default;
